import { Injectable } from '@angular/core';
import {AppConfig} from '../app.config';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class TaskService {
  private createTaskUrl = this.config.baseUrl + 'api/task';
  private getListOfUsersTaskUrl = this.config.baseUrl + 'api/task';
  private getListOfUsersTaskSpecialUrl = this.config.baseUrl + 'api/task/special';
  private updateTaskUrl = this.config.baseUrl + 'api/task/id';
  private syncTaskUrl = this.config.baseUrl + 'api/sync_task';
  private todayTask = this.config.baseUrl + 'api/task/?date=today&done=1';
  private yesterdayTask = this.config.baseUrl + 'api/task/?date=yesterday&done=1';
  private thisWeekTask = this.config.baseUrl + 'api/task/?date=this_week&done=1';
  private thisMonthTask = this.config.baseUrl + 'api/task/?date=this_month&done=1';
  private deletePomodoros = this.config.baseUrl + 'api/task/';
  private getTodayTaskWithCategoryUrl = this.config.baseUrl + 'api/task/?date=today&done=1&category=';
  private getYesterdayTaskWithCategoryUrl = this.config.baseUrl + 'api/task/?date=yesterday&done=1&category=';
  private getWeekTaskWithCategoryUrl = this.config.baseUrl + 'api/task/?date=this_week&done=1&category=';
  private getMonthTaskWithCategoryUrl = this.config.baseUrl + 'api/task/?date=this_month&done=1&category=';
  private getAllDoneTask = this.config.baseUrl + 'api/task?done=1';
  private todayDoneTask = this.config.baseUrl + 'api/task/?date=today&done=1';
  private todayTodoTask = this.config.baseUrl + 'api/task/?date=today&todo=1';
  constructor(private config: AppConfig,
              private http: HttpClient) { }
  createTask(task): Observable<any>{
    return this.http.post(this.createTaskUrl, task, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
        Content_Language: localStorage.getItem('trans')
      },
    }).pipe(map((response: Response) => {
      return response;
    }));
  }
  getTodayTask(): Observable<any>{
    return this.http.get(this.todayTask, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
        Content_Language: localStorage.getItem('trans')
      },
    }).pipe(map((response: Response) => {
      return response;
    }));
  }
  getYesterdayTask(): Observable<any>{
    return this.http.get(this.yesterdayTask, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
        Content_Language: localStorage.getItem('trans')
      },
    }).pipe(map((response: Response) => {
      return response;
    }));
  }
  getThisWeekTask(): Observable<any>{
    return this.http.get(this.thisWeekTask, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
        Content_Language: localStorage.getItem('trans')
      },
    }).pipe(map((response: Response) => {
      return response;
    }));
  }
    getThisMonthTask(): Observable<any>{
    return this.http.get(this.thisMonthTask, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
        Content_Language: localStorage.getItem('trans')
      },
    }).pipe(map((response: Response) => {
      return response;
    }));
  }
  getListOfUsersTask(): Observable<any>{
    return this.http.get(this.getListOfUsersTaskSpecialUrl, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
        Content_Language: localStorage.getItem('trans')
      },
    }).pipe(map((response: Response) => {
      return response;
    }));
  }
  updateTask(task): Observable<any>{
    return this.http.post(this.updateTaskUrl, task, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
        Content_Language: localStorage.getItem('trans')
      },
    }).pipe(map((response: Response) => {
      return response;
    }));
  }
  syncTask(tasks): Observable<any>{
    return this.http.post(this.syncTaskUrl, {
      tasks
    }, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
        Content_Language: localStorage.getItem('trans')
      }
    }).pipe(map( (response: Response) => {
      return response;
    }));
  }
  deleteTaskWithPomodoros(id): Observable<any>{
    return this.http.delete(this.deletePomodoros + id, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
        Content_Language: localStorage.getItem('trans')
      },
    }).pipe(map((response: Response) => {
      return response;
    }));
  }
  getTodayTaskWithCategory(category): Observable<any>{
    return this.http.get(this.getTodayTaskWithCategoryUrl + category, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
        Content_Language: localStorage.getItem('trans')
      },
    }).pipe(map((response: Response) => {
      return response;
    }));
  }
  getYesterdayTaskWithCategory(category): Observable<any>{
    return this.http.get(this.getYesterdayTaskWithCategoryUrl + category, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
        Content_Language: localStorage.getItem('trans')
      },
    }).pipe(map((response: Response) => {
      return response;
    }));
  }
  getWeekTaskWithCategory(category): Observable<any>{
    return this.http.get(this.getWeekTaskWithCategoryUrl + category, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
        Content_Language: localStorage.getItem('trans')
      },
    }).pipe(map((response: Response) => {
      return response;
    }));
  }
  getMonthTaskWithCategory(category): Observable<any>{
    return this.http.get(this.getMonthTaskWithCategoryUrl + category, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
        Content_Language: localStorage.getItem('trans')
      },
    }).pipe(map((response: Response) => {
      return response;
    }));
  }
  getAllDoneTaskInfo(): any{
    return this.http.get(this.getAllDoneTask, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
        Content_Language: localStorage.getItem('trans')
      },
    }).pipe(map((response: Response) => {
      return response;
    }));
  }
  todo(): any{
    return this.http.get(this.todayTodoTask, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
        Content_Language: localStorage.getItem('trans')
      },
    }).pipe(map((response: Response) => {
      return response;
    }));
  }
  done(): any{
    return this.http.get(this.todayDoneTask, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
        Content_Language: localStorage.getItem('trans')
      },
    }).pipe(map((response: Response) => {
      return response;
    }));
  }
  getList(): any{
    return this.http.get(this.getListOfUsersTaskUrl, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
        Content_Language: localStorage.getItem('trans')
      },
    }).pipe(map((response: Response) => {
      return response;
    }));
  }
}
